export const formatNumber = (num?: number, isInt?: boolean) => {
  if (num === undefined || num === null) return "N/A";
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`;
  }
  if (isInt) {
    return Math.round(num).toString();
  }
  return num.toFixed(2);
};

export const formatCurrency = (currencySymbol: string, num?: number) => {
  if (num === undefined || num === null) return "N/A";
  return `${currencySymbol}${formatNumber(num)}`;
};

export const formatPercentage = (num?: number, multiply: boolean = true) => {
  if (num === undefined || num === null) return "N/A";
  return `${(multiply ? num * 100 : num).toFixed(2)}%`;
};

export const compactNumberFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  compactDisplay: "short",
  maximumFractionDigits: 1,
});
